import AxiosClient from "../../../services/axios.services";

class DisciplinaryActionServices {
  getDisciplinaryAction = (params) =>
    AxiosClient.get("/api/app/sanciones_motivo_accion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveDisciplinaryAction = (data) =>
    AxiosClient.post("/api/app/sanciones_motivo_accion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editDisciplinaryAction = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_motivo_accion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteDisciplinaryAction = (id) =>
    AxiosClient.delete(`/api/app/sanciones_motivo_accion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new DisciplinaryActionServices();
